class LazyPlayer extends HTMLElement {
  constructor() {
    super();
    
    this.player = this.querySelector('iframe');
    this.initIntersectionObserver();
  }

  onLoad() {
    const src = this.player.getAttribute('lazy-src');
    this.player.setAttribute('src', src);
    this.player.removeAttribute('lazy-src');
  }

  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.onLoad();
  }

  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = '10px';
    this.observer = new IntersectionObserver(this.observerCallback.bind(this), {
      rootMargin
    });
    this.observer.observe(this);
  }

  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}

customElements.define('lazy-player', LazyPlayer);